import type { GridColDef } from '@mui/x-data-grid-pro';

export const DEFAULT_COLUMN_SETTINGS: Partial<GridColDef> = {
  resizable: false,
  sortable: false,
  filterable: false,
  disableColumnMenu: true,
  headerAlign: 'center'
};
